export default __webpack_public_path__ + "static/franchiseProcessEN-2c7c5aa37d7e438d08b00ba2f0b5ef79.jpg";